import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import classnames from 'classnames';

interface Props extends ComponentPropsWithRef<'div'> {
  subtitle: string;
  isArticle?: boolean;
}

const ContentSubtitle: FC<Props> = ({ isArticle = false, className, subtitle, ...rest }) => {
  const rootClass = classnames('content-subtitle', className);

  return (
    <Text className={rootClass} variant={isArticle ? 'new-big' : 'big'} {...rest}>
      {subtitle}
    </Text>
  );
};

export { ContentSubtitle };
